import z from 'zod'

export const SetPaymentSessionSchema = z.object({
    cart_id: z.string().min(1),
    provider_id: z.string().min(1),
})
